import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for `/libraries/milestone-catalog/*`.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const milestonesCatalogRoute = defineRoute("/libraries/milestone-catalog");
export const milestoneCatalogRoute = defineRoute("/libraries/milestone-catalog/:idOrAdd");
